import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { Button } from '@newComponents/Button/Button'

import { HeroCopyText } from './styles'

export function CallToActionButton() {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <Button
      paddingVertical='$4'
      paddingHorizontal='$8'
      borderRadius='$8'
      onPress={() => {
        navigate('/sign-up', { state: { backgroundLocation: location } })
      }}
    >
      <HeroCopyText size='$6' $gtXs={{ size: '$7' }}>
        Let&apos;s go
      </HeroCopyText>
    </Button>
  )
}
